/**
 *  Games launcher
 */

define(function(require, exports, module) {
    'use strict';
    const _ = require('underscore');
    const core = require('core');
    const i18n = require('i18n');
    const device = require('util/device.util');
    const Launcher = require('modules/launcher/launcher');

    _.extend(Launcher, {
        _handleSuccessLogin: function(gameCode, mode, queryString, options) {

            if (!device.isDesktop) {
                return this.launchGame(gameCode, mode, queryString, options);
            }

            if (this._isLaunchInNewWindow(gameCode)) {
                var buttonTitle = i18n.t('playtech.mobile.system.button.realPlay');
                var popupContent = i18n.t('playtech.mobile.system.games.popup-blocker-with-confirm');

                window.Playtech.API.popup.showPopup({
                    content: popupContent,
                    className: 'popup-blocker-with-confirm',
                    buttons: [
                        {
                            text: buttonTitle,
                            onClick: () => this.launchGame(gameCode, mode, queryString, options)
                        }
                    ],
                    onClose: function() {
                        core.trigger('page:refresh');
                    }
                });
            } else {
                this.launchGame(gameCode, mode, queryString, options);
            }
        }
    });

    module.exports = Launcher;
});
